<form>
  <div class="mb-3">
    <label for="notes" class="my-1"><strong>ADDITIONAL DETAILS </strong>({{ additionalDetailsRequired ? "Required" : "Optional" }})</label>
    <textarea
      id="notes"
      name="notes"
      class="form-control"
      rows="3"
      [(ngModel)]="formModel.notes"
      (change)="onNotesChange()"
      [disabled]="formDisabled || task.frozen"
    >
    </textarea>
  </div>
</form>
<div *ngIf="serverError" class="mb-3">
  <div class="alert alert-danger p-2">{{ serverErrorMsg }}</div>
</div>
<div class="text-end mt-2">
  <button *ngIf="submitAllowed" class="btn btn-primary" [disabled]="!submitEnabled" (click)="onSubmitClick($event)">
    <fa-icon [icon]="['fas', 'cloud-upload-alt']" /> Submit to R1
  </button>
  <button *ngIf="nextButtonEnabled" class="btn btn-secondary" (click)="onNextClick($event)">
    Next <fa-icon [icon]="['fas', 'angle-double-right']" />
  </button>
</div>
